import React from 'react';
import { Search, Bell, HelpCircle } from 'lucide-react';
interface HeaderProps {
  title: string;
  onNotificationClick?: () => void;
}
export function Header({
  title,
  onNotificationClick
}: HeaderProps) {
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 sticky top-0 z-40" data-id="element-57">
      <h1 className="text-xl font-bold text-slate-800" data-id="element-58">{title}</h1>

      <div className="flex items-center gap-6" data-id="element-59">
        <div className="relative" data-id="element-60">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-4 w-4" data-id="element-61" />
          <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-famo-gold/50 focus:border-famo-gold w-64 transition-all" data-id="element-62" />
        </div>

        <div className="flex items-center gap-4" data-id="element-63">
          <button onClick={onNotificationClick} className="text-slate-500 hover:text-famo-navy transition-colors relative" data-id="element-64">
            <Bell size={20} data-id="element-65" />
            <span className="absolute -top-1 -right-1 h-4 w-4 bg-red-500 rounded-full text-[10px] font-bold text-white flex items-center justify-center border-2 border-white" data-id="element-66">
              3
            </span>
          </button>
          <button className="text-slate-500 hover:text-famo-navy transition-colors" data-id="element-67">
            <HelpCircle size={20} data-id="element-68" />
          </button>
        </div>
      </div>
    </header>;
}